import { withInstall } from '@lit-element/utils'
import Backtop from './src/backtop.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtBacktop: SFCWithInstall<typeof Backtop> = withInstall(Backtop)
export default LtBacktop

export * from './src/backtop'
export type { BacktopInstance } from './src/instance'
